import { AddressId } from '../../domain/entities/Address';
import { IPurchaserInfo } from '../../domain/entities/Store/Store';
import { IStoreInformation } from '../IApiResponses';

export interface IClickCollectPayloadData {
  store: IStoreInformation;
  purchaser_details: {
    first_name: string;
    last_name: string;
    phone: string;
  };
}

export interface IClickCollectData {
  store: IStoreInformation;
  purchaserDetails: IPurchaserInfo;
  id?: AddressId;
}

const clickAndCollectDataMapper = {
  request(data: { purchaserDetails: IPurchaserInfo, store: IStoreInformation }): IClickCollectPayloadData {

    const { firstName, lastName, phone } = data.purchaserDetails;
    return {
      purchaser_details: {
        first_name: firstName,
        last_name: lastName,
        phone,
      },
      store: data.store,
    };
  },
};

export default clickAndCollectDataMapper;
